import React, { memo, useCallback, useState } from 'react';
import { createUseStyles, Input, Button, Advice } from 'hoi-poi-ui';
import useLoginLiterals from "../../../lib/useLoginLiterals";
import { FadeTransition } from "../../../components/Transitions";
import AuthBox from "../components/AuthBox";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'RecoverPassword');
const RecoverPassword = _ref => {
  let {
    logo,
    onSend,
    iframeURL
  } = _ref;
  const classes = useStyles();
  const [username, setUsername] = useState();
  const [formState, setFormState] = useState({
    error: null,
    success: null,
    loading: false
  });
  const {
    loading,
    t
  } = useLoginLiterals();
  const send = useCallback(e => {
    var _e$preventDefault;
    e === null || e === void 0 ? void 0 : (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 ? void 0 : _e$preventDefault.call(e);
    if (!username) return;
    setFormState({
      error: null,
      success: null,
      loading: true
    });
    onSend(username).then(successLiteral => {
      setFormState({
        success: successLiteral ? t(successLiteral) : t('succes_new_password_email_sent'),
        error: false,
        loading: false
      });
      setUsername('');
    }).catch(e => {
      console.error(e);
      setFormState({
        success: false,
        error: t('error_generalerror'),
        loading: false
      });
    });
  }, [onSend, t, username]);
  if (loading) return null;
  return /*#__PURE__*/React.createElement(AuthBox, {
    title: t('label_change_password'),
    logo: logo,
    iframeURL: iframeURL ? t(iframeURL) : null
  }, /*#__PURE__*/React.createElement(FadeTransition, {
    transitionKey: "error",
    show: formState.error
  }, /*#__PURE__*/React.createElement(Advice, {
    className: classes.advice,
    type: "error",
    showIcon: true,
    defaultCollapsed: false,
    showCollapse: false
  }, formState.error)), /*#__PURE__*/React.createElement(FadeTransition, {
    transitionKey: "sucess",
    show: formState.success
  }, /*#__PURE__*/React.createElement(Advice, {
    className: classes.advice,
    type: "success",
    showIcon: true,
    defaultCollapsed: false,
    showCollapse: false
  }, formState.success)), /*#__PURE__*/React.createElement("form", {
    onSubmit: send
  }, /*#__PURE__*/React.createElement(Input, {
    label: t('label_email_or_mobile_login'),
    placeholder: t('label_email_or_mobile_login'),
    type: "text",
    onChange: setUsername,
    value: username,
    isFullWidth: true,
    isDisabled: formState.loading,
    autoFocus: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: send,
    isLoading: formState.loading
  }, t('action_next')))));
};
export default /*#__PURE__*/memo(RecoverPassword);